module.exports = __webpack_public_path__ + "static/whats-causing-americans-stress-2017-1-0e0b611eb898ad722ffd859c02740fc0.png";